export default {
    Categories:[],
    product:{}

}